export default {
    Categories:[],
    product:{}

}